export function refreshSticky(selector = '.ui.sticky') {
  $(selector).filter(function() {
    return $(this).data('module-sticky') !== undefined;
  }).sticky('refresh');
}
